import { Box, Stack, Typography } from '@mui/material';
import { getSelectorAttribute } from '@vy/app-selectors';
import React from 'react';
import type { PlanCreationOptionConfig } from '../../config/plan-creation-options';

type PlanCreationOptionCardProps = {
  option: PlanCreationOptionConfig;
  selected: boolean;
  onSelect: (value: PlanCreationOptionConfig['value']) => void;
  selectorAttribute?: string;
};

export const PlanCreationOptionCard: React.FC<PlanCreationOptionCardProps> = ({
  option,
  selected,
  onSelect,
  selectorAttribute,
}) => {
  const handleClick = () => {
    if (option.disabled) {
      return;
    }

    onSelect(option.value);
  };

  return (
    <Stack
      spacing={2}
      sx={{
        flex: 1,
        padding: 3,
        border: `1px solid ${selected ? '#5083FF' : '#E8EBF2'}`,
        borderRadius: '8px',
        alignItems: 'center',
        cursor: option.disabled ? 'not-allowed' : 'pointer',
        backgroundColor: selected ? '#F5F6FA' : '#fff',
        opacity: option.disabled ? 0.4 : 1,
        pointerEvents: option.disabled ? 'none' : 'auto',
        transition: 'all 0.2s ease-in-out',
        ...(!selected &&
          !option.disabled && {
            '&:hover': {
              borderColor: '#B0D2FF',
              backgroundColor: '#F5F6FA',
            },
          }),
      }}
      onClick={handleClick}
      {...(selectorAttribute ? getSelectorAttribute(selectorAttribute) : {})}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 62,
          height: 62,
          borderRadius: '50%',
          backgroundColor: option.iconBackground,
        }}
      >
        {option.icon}
      </Box>
      <Stack spacing={0.5}>
        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '14px', textAlign: 'center' }}>
          {option.title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            fontSize: '14px',
            textAlign: 'center',
            lineHeight: 1.5
          }}>
          {option.description}
        </Typography>
      </Stack>
    </Stack>
  );
};
